import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CompanyModel} from '../../../../../shared/models/company.model';
import {PortfolioService} from '../../../portfolio.service';
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-new-portfolio-cart-dialog',
  templateUrl: './new-portfolio-cart-dialog.component.html',
  styleUrls: ['./new-portfolio-cart-dialog.component.scss'],
  imports: [MaterialModule, FormsModule, CommonModule],
  standalone: true,
})
export class NewPortfolioCartDialogComponent implements OnInit {

  list: any[] = [];
  selected: any[] = [];
  weightError = false;
  hasETF = false;

  constructor(
    public dialogRef: MatDialogRef<NewPortfolioCartDialogComponent>,
    private service: PortfolioService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.selected = [];
    this.dialogRef.close();
  }

  ngOnInit(): void {
    if (this.data.list) {
      this.list = [...this.data.list];
      this.checkETF();
    }
  }

  onSaveClick() {
    this.selected = [];
    this.dialogRef.close({list: this.list});
  }

  onRemoveClick() {
    this.list = this.list.filter(i => !i.markedForDelete);
    this.selected = [];
    this.recalculateWeight();
    this.checkETF();
  }

  onSelect(value, item) {
    this.selected = this.selected.includes(item) ? this.selected.filter(i => i !== item) : [ ...this.selected, item ];
    item.markedForDelete = value.checked;
  }

  recalculateMarketCapWeight() {
    let freeWeight = 100;

    if (this.hasETF) {
      freeWeight = 100 - this.data.portfolio.etfPercent;
      const selectedETFLength = this.list.filter(c => c.isETF()).length;
      this.list = this.list.map((company: CompanyModel) => {
        if (!company.isStock()) {
          company.weight = +(this.data.portfolio.etfPercent / selectedETFLength).toFixed(2);
        }
        return company;
      });
    }
    let totalMarketCap = 0;
    this.list.map((company: CompanyModel) => {
      if (company.isStock()) {
        totalMarketCap += +company.market_value_usd;
      }
      if (company.isFund()) {
        totalMarketCap += +company.fund_reference_table.AverageMarketCapital;
      }
    });
    this.list = this.list.map((company: CompanyModel) => {
      if (company.isStock()) {
        company.weight = +(+company.market_value_usd/totalMarketCap*freeWeight).toFixed(2);
      }
      if(company.isFund()){
        company.weight = +(+company.fund_reference_table.AverageMarketCapital/totalMarketCap*freeWeight).toFixed(2);
      }
      return company;
    });
  }

  recalculateWeight() {
    if (this.data.portfolio.weighting_type === 'market_cap') { // market cap
      this.recalculateMarketCapWeight();
      return;
    }

    // recalculate equal weights
    let selectedStockLength = this.list.filter(c => c.isStock() || c).length;
    let freeStockWeight = 100 - this.data.portfolio.etfPercent;

    let selectedETFLength = this.list.filter(c => c.isETF()).length;
    let freeETFWeight = this.data.portfolio.etfPercent;

    if (selectedStockLength || selectedETFLength) {
      this.list.map((company: CompanyModel) => {
        if (company.weightManuallyAdjusted) {
          if (company.isStock()) {
            selectedStockLength -= 1;
            freeStockWeight -= company.weight;
          } else {
            selectedETFLength -= 1;
            freeETFWeight -= company.weight;
          }
        }
      });
      this.list = this.list.map((company: CompanyModel) => {
        if (!company.weightManuallyAdjusted) {
          if (company.isStock()) {
            company.weight = +(freeStockWeight / selectedStockLength).toFixed(2);
          } else {
            company.weight = +(freeETFWeight / selectedETFLength).toFixed(2);
          }
        }
        return company;
      });
      this.weightError = freeStockWeight < 0 || freeETFWeight < 0;
    }

  }

  onWeightTypeChange() {
    if (this.data.portfolio.weighting_type === 'equal') { // equal
      this.list = this.list.map((company: CompanyModel) => {
        company.weightManuallyAdjusted = false;
        return company;
      });
      this.recalculateWeight();
    } else if (this.data.portfolio.weighting_type === 'market_cap') { // market cap
      this.recalculateMarketCapWeight()
    }
  }

  onWeightChange(company) {
    this.data.portfolio.weighting_type = 'manual';
    company.weightManuallyAdjusted = company.weight;
    this.recalculateWeight();
  }

  checkETF() {
    this.hasETF = this.service.hasETF(this.list);
  }
}
